import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/banner/list',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/banner/destroy',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/banner/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/banner/createOrUpdate',
      method: 'post',
      data
    })
  },
  Detail(id) {
    return request({
      url: 'admin/banner/detail',
      method: 'post',
      params: { id }
    })
  }
}

export default api
